import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const sort: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M7.844-3.844c.101.094.156.211.156.344q0 .204-.14.344L4.36.359A.53.53 0 0 1 4 .5a.47.47 0 0 1-.344-.14l-3.5-3.516A.44.44 0 0 1 0-3.5q0-.201.14-.344A.5.5 0 0 1 .5-4h7c.133 0 .25.055.344.156m.015-3.015Q8-6.7 8-6.5a.5.5 0 0 1-.156.36A.47.47 0 0 1 7.5-6h-7a.52.52 0 0 1-.36-.14A.52.52 0 0 1 0-6.5q-.002-.2.156-.36l3.5-3.5A.47.47 0 0 1 4-10.5q.2 0 .36.14zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 10.5)"
    />
  ),
  svgProps: {
    height: "11",
    width: "8",
  }
};
